/*
 * @Author: liyxt
 * @Date: 2020-05-28 14:28:27
 * @LastEditors: bbqin
 * @LastEditTime: 2022-04-18 11:22:41
 * @Description: file content
 */
import React, { Component } from 'react';
//import OriginAffix from 'bee-affix';
import { Affix as OriginAffix } from '@tinper/next-ui';
import { microAppUtil } from '@platform/api';

//require('bee-affix/build/Affix.css');
import "./index.less";

const { getPopContainer } = microAppUtil;

/**
 * @namespace Affix
 */

/**
 * Affix组件的参数描述
 * @memberof Affix
 * @component Affix
 * @property {number} offsetTop=0 固定被触发距离，默认是0 ，可选的属性
 * @property {boolean} horizontal=false 被固定时是否可以左右滑动，默认是false，可选的属性
 * @property {function} target=()=>window	设置 Affix 需要监听其滚动事件的元素，值为一个返回对应 DOM 元素的函数，默认值() => window
 * @property {function} onChange 触发固定或者固定取消时的回调函数,返回值{ affixed: true, event: evt}
 * @property {function} onTargetChange 时刻获取Affix的状态值,返回值{state}
 * @property {Object} childrenRef child是动态变化的时候，使用该属性重新计算child宽高
 * @property {Object} getPopupContainer=document.body 固定元素所属容器
 * @property {number} offsetBottom 距离窗口底部达到指定偏移量后触发
 * @property {boolean} initCalc=false 页面初始时是否计算DOM需要定位
 * @property {string} className 自定义className
 */
class Affix extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cls: '',
            //defaultContainer: null,
        };
    }

    // componentDidMount(){
    // 	let { container } = this.props;
    // 	if(!container){
    // 		//此处加 container是由于 2005及之前版本 滚动条在html affix默认container是body
    // 		// 2012滚动条在body, affix固定效果失效  需要添加target和container属性才有效
    // 		this.setState({
    // 			defaultContainer: document.querySelector('#app')
    // 		})
    // 	}
    // }

    /**
     * 触发固定或者固定取消时的回调函数,返回值obj :{ affixed: true, event: evt}
     */
    targetChange = val => {
        if (val.initTop === val.top || val.initTop + val.top == 2) {
            this.setState({ cls: '' });
        } else {
            this.setState({ cls: 'tringer-affixed-bg' });
        }
    }
    onChange = obj => {
        let { onChange } = this.props;
        let { affixed } = obj;

        if (affixed == false) {
            this.setState({ cls: '' });
        } else {
            this.setState({ cls: 'tringer-affixed-bg' });
        }
        if (typeof onChange === 'function') {
            onChange(obj);
        }
    }
    
    render() {
        //let { cls, target, defaultContainer } = this.state;
        let { container, getPopupContainer, className = "" } = this.props;
        return <div id='out-wrapper'>
            <OriginAffix
                {...this.props}
                onTargetChange={this.targetChange}
                getPopupContainer={getPopupContainer || container}
                //container = {container? container: defaultContainer}
                offsetTop={0.1}
                //initCalc
                zIndex={200}
                className={`${className} ${this.state.cls}`}
                onChange={this.onChange}
                // target={target ? target : (appContainer ? () => appContainer : undefined ) }
            />
        </div>;
    }
}

export default Affix;
